export const fieldValidity = Object.freeze({
    "SUCCESS": "success",
    "ERROR": "error",
    "WARNING": "warning",
})